/** Salesforce Lightning tab URL that re-enters Labra Canvas with a SPA path in the hash. */
export function buildSalesforceLabraCanvasGuidedHref(
  salesforceInstanceUrl: string,
  labraSpaPath: string
): string {
  const instance = salesforceInstanceUrl.trim().replace(/\/$/, '')
  const labraPath = labraSpaPath.trim()
  if (!instance || !labraPath) {
    return ''
  }
  const path = labraPath.startsWith('/') ? labraPath : `/${labraPath}`
  return `${instance}/lightning/n/LabraIo__Labra#canvasParamTargetURL=${encodeURIComponent(
    path
  )}`
}
